<template>
    <div class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <div class="board">
                    <div class="center-area">
                        <center-navigation />
                        <div class="center-board">
                            <notification-list v-if="!$route.params._notification"></notification-list>
                            <notification-view v-else></notification-view>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import NotificationList from "@/components/client/center/notifications/notification-list.vue";
import NotificationView from "@/components/client/center/notifications/notification-view.vue";
import CenterNavigation from "@/components/client/center/center-navigation.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        CenterNavigation,
        NotificationList,
        NotificationView,
    },
};
</script>
